module.exports = __webpack_public_path__ + "static/media/tortoise08.11047675.png";